import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var HeirarchicalEvent = /** @class */ (function (_super) {
    __extends(HeirarchicalEvent, _super);
    function HeirarchicalEvent(type, property) {
        var _this = _super.call(this, type) || this;
        _this.property = property;
        return _this;
    }
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    HeirarchicalEvent.prototype.clone = function () {
        return new HeirarchicalEvent(this.type, this.property);
    };
    /**
     *
     */
    HeirarchicalEvent.INVALIDATE_PROPERTY = 'invalidateProperty';
    return HeirarchicalEvent;
}(EventBase));
export { HeirarchicalEvent };
